export default {
    titleExplore: 'Conhecimento',
    subTitleExplore: 'Aprenda sobre temas como Astrologia, tarot e relacionamento',
    title: 'Conhecimento',
    subTitle: 'Aprenda sobre Astrologia',

    articles: {
        title: 'Blog',
        description: 'Aprofunde seus conhecimentos',
        link: 'posts'
    },

    blog: {
        title: 'Lições Astrológicas',
        description: 'Aprenda mais sobre astrologia',
        link: 'astrology-lessons'
    },

    tarot: {
        title: 'Tarot',
        description: 'Respostas para seus questionamentos',
        link: 'tarot'
    },

    signs: {
        title: 'Signos',
        description: 'Conheça cada signo do zodíaco',
        link: 'signos'
    },

    houses: {
        title: 'Casas',
        description: 'Entenda as Casas Astrológicas',
        link: 'casas'
    },

    stars: {
        title: 'Planetas',
        description: 'O papel dos astros na astrologia',
        link: 'planetas'
    },

    synastry: {
        title: 'Combinação signos',
        description: 'A combinação de seu signo com outros.',
        link: 'combinacao-de-signos'
    },

    label: {
        sign: 'Signos',
        tarotMajor: 'Tarot - Arcanos Maiores',
        tarotMinor: 'Tarot - Arcanos Menores',
        planet: 'Planetas',
        house: 'Casas Astrológicas',
        article: 'Artigos'
    },

    errorComponent: 'Não foi possível carregar os artigos'
}